import type { SlotKey } from '../types';

/** One row in the v4 builder day plan (standard meal shares + default times). */
export type BuilderSlot = {
  key: SlotKey;
  mealTypesId: string;
  name: string;
  time: string;
  share: number;
  orderNo: number;
};

/**
 * Standard meal shares for the diet-plan builder (v4 wireframe).
 * Sum = 100%. Used for new plans and when toggling “Standard meal shares”.
 */
export const BUILDER_SLOTS: BuilderSlot[] = [
  {
    key: 'early_morning',
    mealTypesId: 'd6a528b8-26fb-11ef-a2b6-0022486e34ba',
    name: 'Early morning',
    time: '06:30',
    share: 5,
    orderNo: 0,
  },
  {
    key: 'breakfast',
    mealTypesId: '8890099d-37e4-11ec-ae06-4ec4eb4dc0dd',
    name: 'Breakfast',
    time: '08:30',
    share: 20,
    orderNo: 1,
  },
  {
    key: 'morning_snacks',
    mealTypesId: '8ccb64e7-37e4-11ec-ae06-4ec4eb4dc0dd',
    name: 'Morning snack',
    time: '11:00',
    share: 10,
    orderNo: 2,
  },
  {
    key: 'lunch',
    mealTypesId: '91210cf6-37e4-11ec-ae06-4ec4eb4dc0dd',
    name: 'Lunch',
    time: '13:30',
    share: 30,
    orderNo: 3,
  },
  {
    key: 'evening_snacks',
    mealTypesId: '955ad3c4-37e4-11ec-ae06-4ec4eb4dc0dd',
    name: 'Evening snack',
    time: '17:00',
    share: 10,
    orderNo: 4,
  },
  {
    key: 'dinner',
    mealTypesId: '994d3bcb-37e4-11ec-ae06-4ec4eb4dc0dd',
    name: 'Dinner',
    time: '20:00',
    share: 20,
    orderNo: 5,
  },
  {
    key: 'bed_time',
    mealTypesId: '9a7e4cdc-37e4-11ec-ae06-4ec4eb4dc0dd',
    name: 'Bedtime',
    time: '22:00',
    share: 5,
    orderNo: 6,
  },
];
